import { ArabicEach, findRecursive } from '@/mm/utils.js'

export function washData(walkedNode) {
  let ArabicRule = [
    {
      flag: 'rc_list_title',
      dataType: ['design', 'design'],
      onlyEnglish: ['title_textAlign', false],
      englishTitleLeft: ['left', 'self_marginLeft'],
      englishTitleRight: ['right', 'self_marginRight']
    },
    {
      flag: 'rc_button_flag',
      dataType: ['design'],
      onlyEnglish: [false],
      englishTitleLeft: ['self_marginLeft'],
      englishTitleRight: ['self_marginRight']
    }
  ]
  ArabicEach(walkedNode, ArabicRule)
}
